<template>
	<page>
		<module>
			<view-list ref="view" work-type="4" selector :view-config="auth('b_product_archive_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="商品编码">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="规格型号">
							<c-input name="spec_model"></c-input>
						</m-search-item>
                        <m-search-item label="状态">
							<c-select name="is_enabled" :options="disableEnableDic"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_product_archive_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

                <template #is_enabled="{data}">
                    <c-state dict="disableEnableDic" :value="data.is_enabled"></c-state>
                </template>
				
				<c-table-column
					type="button"
					label="操作"
					width="110"
					button-limit="2"
				>
					<template #default="{data}">
						<c-table-button icon="tf-edit" @click="globalDialog('productDetail', {props: {id: data.id,inventory_code: data.inventory_code}})">查看</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			// 获取dictName选项数据
			...mapState(['openCloseDic','disableEnableDic'])
		},
		
		data() {
			return {
			}
		},
		
		methods: {

		}
	}
</script>

<style lang="stylus" scoped>
</style>